// extracted by mini-css-extract-plugin
module.exports = {"empty":"index-module--empty--32KPj"};